/**
 * Alert tones made with WebAudio; no sound files. Browsers only start audio after a user
 * gesture, so the game calls unlockAudio() on the first click or key press.
 */
export type AlertTone = 'conflict' | 'warning' | 'good' | 'emergency' | 'collision';

let ctx: AudioContext | null = null;

function audio(): AudioContext | null {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

export function unlockAudio(): void { audio(); }

function tone(a: AudioContext, freq: number, at: number, dur: number, volume: number): void {
  const osc = a.createOscillator(), gain = a.createGain();
  osc.type = 'triangle';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, at);
  gain.gain.exponentialRampToValueAtTime(volume, at + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  osc.connect(gain).connect(a.destination);
  osc.start(at);
  osc.stop(at + dur + 0.02);
}

export function playAlert(kind: AlertTone): void {
  const a = audio();
  if (!a || a.state !== 'running') return;
  const t = a.currentTime;
  // A declared emergency: a low two-tone call, distinct from the separation alarm above it.
  if (kind === 'collision') { tone(a, 175, t, 0.65, 0.25); tone(a, 110, t + 0.25, 0.8, 0.22); }
  else if (kind === 'emergency') { tone(a, 392, t, 0.28, 0.16); tone(a, 311, t + 0.3, 0.38, 0.16); }
  else if (kind === 'conflict') for (let i = 0; i < 3; i++) tone(a, 880, t + i * 0.18, 0.13, 0.18);
  else if (kind === 'warning') tone(a, 660, t, 0.22, 0.12);
  else { tone(a, 523, t, 0.1, 0.07); tone(a, 784, t + 0.1, 0.16, 0.07); }
}
